import { useMemo } from 'react';

import { ProductSearchItem } from '../model';

export const useProductMarketingTag = (product: ProductSearchItem) => {
    const marketingTag = useMemo(() => {
        if (!product?.marketingTag) {
            return null;
        }
        const { marketingTagStartTime, marketingTagEndTime } = product;
        const now = new Date();
        const beforeStart = marketingTagStartTime && now < new Date(marketingTagStartTime);
        const afterEnd = marketingTagEndTime && now > new Date(marketingTagEndTime);

        if (beforeStart || afterEnd) {
            return null;
        }

        return product.marketingTag;
    }, [product]);

    return marketingTag;
};
